import * as React from "react";
import { useRef } from "react";
import { Redirect, useHistory, useParams } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Layout } from "../../components/Layout";
import { VehicleHistoryView } from "../../components/VehicleHistory/VehicleHistoryView";
import { useHasVehicleHistory } from "../../hooks/useUiv";
import { useStickyBottom } from "../../hooks/useStickyBottom";

const VehicleHistoryPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { goBack } = useHistory();
  const hasVehicleHistory = useHasVehicleHistory();
  const appBarRef = useRef<HTMLElement>(null);
  const appBarBottom = useStickyBottom(() => appBarRef.current);

  if (!hasVehicleHistory) return <Redirect to="/" />;

  return (
    <Layout
      appBar={
        <AppBar ref={appBarRef} position="sticky">
          <Toolbar>
            <IconButton onClick={goBack} aria-label="Back">
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6">Vehicle History</Typography>
          </Toolbar>
        </AppBar>
      }
    >
      <VehicleHistoryView vehicleId={id} stickyTop={appBarBottom} />
    </Layout>
  );
};

export default VehicleHistoryPage;
